import http, { API_BASE, handler } from './http-service';

const baseURL = `${API_BASE}/users`;

export const login = async (username: string, password: string) => {
  const url = `${baseURL}/login`;
  return handler(() => http.post(url, { username, password }))
}

export const loginAlternate = async (userId: string, adminPassword: string) => {
  const url = `${baseURL}/login-alternate`;
  return handler(() => http.post(url, { userId, adminPassword }))
}

export const resetPassword = async (password: string) => {
  const url = `${baseURL}/password`;
  return handler(() => http.put(url, { password }));
}

export const forgetPassword = async (phoneNumber: string) => {
  const url = `${baseURL}/password/${phoneNumber}`;
  return handler(() => http.get(url));
}

export default {
  login,
  loginAlternate,
  resetPassword,
  forgetPassword
}
